<template>
  <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Charging Status</ion-title>
          <ion-icon :icon="homeSharp" class="ion-margin ios" @click="homePage"></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar class="app-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Charging Status</ion-title>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ChargingStatusView />
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent } from "@ionic/vue";
import { homeSharp } from 'ionicons/icons';
import ChargingStatusView from "@/components/customer/ChargingStatusView.vue";

export default defineComponent ({
  name: 'chargingStatus',
  components: {
    IonHeader, 
    IonToolbar, 
    IonButtons, 
    IonBackButton, 
    IonTitle, 
    IonContent,
    ChargingStatusView,
  },
  data() {
      return {
        homeSharp
      }
  },
  methods: {
    homePage() {
      let userRole = localStorage.getItem("user.roleId")
      if(userRole == 2) {
        this.$router.push("/customer/reservation")
      }
    },
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    goBack() {
      if (
        localStorage.getItem("verifystart") != null &&
        localStorage.getItem("verifystart") == "true"
      ) {
        localStorage.removeItem("verifystart");
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/customer/reservations");
      } else {
        this.$router.go(-0);
      }
    },
  },
})
</script>

<style scoped>
.ios ion-icon {
  color: white;
  position: relative;
  left:68%;
}
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #ffffff;
    --background: #ffffff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
}
</style>